import { Modal, ModalProps } from '@distribusion/owl-frontend-ui'
import React, { useMemo } from 'react'

import errorIcon from '@images/common/error.svg'
import successIcon from '@images/common/success.svg'
import bem from '@lib/bem'
import { useTranslation } from '@lib/i18n'

import '@components/NotificationModal/index.scss'

export interface NotificationModalProps extends Pick<ModalProps, 'opened' | 'onClose'>, NotificationMessage {}

const iconMap = {
  success: successIcon,
  error: errorIcon,
}

const accessibilityKeyMap = {
  success: 'accessibility.images.successIcon',
  error: 'accessibility.images.errorIcon',
}

const NotificationModal = ({ opened, title, text, type, onClose }: NotificationModalProps) => {
  const { t } = useTranslation()
  const modalTitle = useMemo(() => {
    const iconSrc = iconMap[type]
    const accessibilityKey = accessibilityKeyMap[type]
    return (
      <div className="column items-center notification-modal__title">
        <img src={iconSrc} alt={t(accessibilityKey)} className={bem('notification-modal', 'icon')} />
        {title && <h3 className={bem('notification-modal', 'text')}>{title}</h3>}
      </div>
    )
  }, [t, title, type])

  return (
    <Modal opened={opened} className="notification-modal" maxWidth={'md'} title={modalTitle} onClose={onClose}>
      <div className="column gap-3 items-center">
        <div>{text}</div>
      </div>
    </Modal>
  )
}

export default NotificationModal
